import React from "react";

const PresentationModeToggle = ({
  presentationMode,
  setPresentationMode,
  disabled = false,
}) => {
  const options = [
    {
      key: "practice",
      label: "Practice",
      description: "Full controls",
      icon: "◎",
      active: !presentationMode,
      onSelect: () => setPresentationMode(false),
    },
    {
      key: "presentation",
      label: "Presentation",
      description: "Student view",
      icon: "▣",
      active: presentationMode,
      onSelect: () => setPresentationMode(true),
    },
  ];

  return (
    <div
      className={[
        "rounded-2xl border border-slate-200 bg-slate-100/80 p-1.5 shadow-inner",
        disabled ? "opacity-55" : "",
      ].join(" ")}
      role="group"
      aria-label="View mode"
      aria-disabled={disabled}
    >
      <div className="grid grid-cols-2 gap-1.5">
        {options.map((option) => (
          <button
            key={option.key}
            type="button"
            onClick={option.onSelect}
            disabled={disabled}
            aria-pressed={option.active}
            className={[
              "flex min-w-0 items-center gap-2 rounded-xl border px-3 py-2.5 text-left transition-all duration-200",
              option.active
                ? "border-slate-200 bg-white text-slate-950 shadow-sm ring-1 ring-white"
                : "border-transparent bg-transparent text-slate-500 hover:border-slate-200 hover:bg-white/65 hover:text-slate-800",
              disabled ? "cursor-not-allowed" : "",
            ].join(" ")}
          >
            <span
              className={[
                "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-xs font-black",
                option.active
                  ? "bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-sm"
                  : "bg-white text-slate-400 shadow-sm",
              ].join(" ")}
              aria-hidden="true"
            >
              {option.icon}
            </span>

            <span className="min-w-0">
              <span
                className={[
                  "block truncate text-xs font-bold",
                  option.active ? "text-slate-950" : "text-slate-600",
                ].join(" ")}
              >
                {option.label}
              </span>
              <span className="mt-0.5 block truncate text-[10px] font-medium text-slate-400">
                {option.description}
              </span>
            </span>
          </button>
        ))}
      </div>

      {disabled && (
        <p className="px-2 pt-1.5 text-center text-[10px] font-medium text-slate-400">
          Write & Echo uses Practice view
        </p>
      )}
    </div>
  );
};

export default PresentationModeToggle;